// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.isconcatspreadable
require('../internals/define-well-known-symbol')('isConcatSpreadable');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.is-concat-spreadable.js
// module id = 286
// module chunks = 1